﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_usuarios/usuarios-main";

export const Route = createFileRoute("/_authenticated/usuarios-main")({
  head: () => ({
    meta: [
      { title: "Usuários da equipe — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Veja quem tem acesso ao sistema e a quem cada lançamento de estoque e venda está associado.",
      },
      { property: "og:title", content: "Usuários da equipe — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Lista da equipe cadastrada e o responsável por cada operação registrada.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
